(function () {
  'use strict';

  angular
    .module('user.marketplace')
    .config(config);

  function config($stateProvider, configOptions) {
    $stateProvider
      .state('user.marketplace', angular.extend({}, configOptions.defaultStateParams, {
        url: '/marketplace',
        templateUrl: 'user/user.tpl.html',
        controller: 'UserCtrl',
        controllerAs: 'user',
        onEnter: ['RouterHelper', function (RouterHelper) {
          RouterHelper.activateTab('user', 'marketplace');
        }]
      }));
  }
}());
